// extracted by mini-css-extract-plugin
export default {"container":"DialogCancelOrderConfirm_container__nge69","icon":"DialogCancelOrderConfirm_icon__gX-XR"};